import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    button: {
      backgroundColor: "#e91e63",
      color: "#fff",
      borderRadius: "50%",
      width: 40,
      height: 40,
      minWidth: 0,
      padding: 0,
    },
    inputTime: {
      '& input[type="datetime-local"]::-webkit-datetime-edit-text': {
        color: 'inherit',
      },
      '& input[type="datetime-local"]::-webkit-datetime-edit-month-field': {
        color: 'inherit',
      },
      '& input[type="datetime-local"]::-webkit-datetime-edit-day-field': {
        color: 'inherit',
      },
      '& input[type="datetime-local"]::-webkit-datetime-edit-year-field': {
        color: 'inherit',
      },
      '& input[type="datetime-local"]::-webkit-datetime-edit-hour-field': {
        color: 'inherit',
      },
      '& input[type="datetime-local"]::-webkit-datetime-edit-minute-field': {
        color: 'inherit',
      },
      '& input[type="datetime-local"]::-webkit-calendar-picker-indicator': {
        filter: 'none',
      },
    },
    badge: (isRequired:boolean) => ({
      '& .MuiBadge-badge': {
        height: "20px",
        width: "20px",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        visibility: isRequired ? 'visible' : 'hidden',
        alignItems: "center",
        background: colors.color12,
        color: colors.color25,
        '& .MuiSvgIcon-root':{
          fontSize: '16px'
        } 
      },
    }),
  }

}